import React, { useEffect, useState } from 'react';
import { Clock, AlertCircle } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function UrgencyBar() {
  const [timeLeft, setTimeLeft] = useState(30 * 60); // 30 minutes in seconds
  const [scarcityCount, setScarcityCount] = useState(7);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  // Format time as MM:SS
  const formatTime = (seconds: number) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };
  return <div className="sticky top-0 z-50 bg-[#2D3436] text-white py-2 px-4 shadow-md" data-id="element-184">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row justify-between items-center text-sm font-medium gap-2" data-id="element-185">
        <div className="flex items-center gap-2 text-[#E8D5D5]" data-id="element-186">
          <Clock size={16} data-id="element-187" />
          <span data-id="element-188">
            Oferta especial termina en:{' '}
            <span className="font-bold text-white tabular-nums" data-id="element-189">
              {formatTime(timeLeft)}
            </span>
          </span>
        </div>

        <div className="flex items-center gap-2 bg-red-500/20 px-3 py-1 rounded-full border border-red-500/30" data-id="element-190">
          <AlertCircle size={16} className="text-red-400" data-id="element-191" />
          <span className="text-red-100" data-id="element-192">
            Solo quedan{' '}
            <span className="font-bold text-white" data-id="element-193">{scarcityCount}</span> copias
          </span>
        </div>
      </div>
    </div>;
}